import ClientTag from '../Models/ClientTag';
import DataGridRequest from './DataGridRequest';
export class ClientTagsRequest extends DataGridRequest<ClientTag> {
    Url = '/settings/tags/api';
}
